<template>
  <div>
    <filter-toolbar
      :hasChanges="hasChanges"
      :appliedFilters="appliedFilters"
      @search="search"
      @update="update"
      @clear="clear">
      <remote-facet-filter
        class="border-b"
        v-model="filters.facets.connection_id"
        response-type="object"
        :resourceLabel="(context.isSupplier()) ? 'retailer.name' : 'brand.name'"
        :filter="filterOptions.connection"
        :endpoint="context.route + '/connections/?short=1'"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.updated_at"
        :filter="filterOptions.updatedAt"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.created_at"
        :filter="filterOptions.createdAt"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.retailer_identifier_created_at"
        :filter="filterOptions.retailerSkuCreated"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.in_stock"
        :filter="filterOptions.inStock"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.is_discontinued"
        :filter="filterOptions.isDiscontinued"
        @input="change"
      />
      <date-filter
        class="border-b"
        v-model="filters.timestamps.brand_inventory_updated_at"
        :filter="filterOptions.submittedAt"
        @input="change"
      />
      <boolean-filter
        class="border-b"
        v-model="filters.facets.is_on_shopify"
        :filter="filterOptions.isOnShopify"
        @input="change"
      />
      <boolean-filter
        v-model="filters.facets.is_on_bigcommerce"
        :filter="filterOptions.isOnBigcommerce"
        @input="change"
      />
    </filter-toolbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as filterOptions from '../../filters/items.js'
import BooleanFilter from '@/components/Filters/BooleanFilter'
import DateFilter from '@/components/Filters/DateFilter'
import RemoteFacetFilter from '@/components/Filters/RemoteFacetFilter'
import FilterToolbar from '@/components/Filters/FilterToolbar'

export default {
  components: {
    BooleanFilter,
    DateFilter,
    FilterToolbar,
    RemoteFacetFilter
  },
  data () {
    return {
      hasChanges: false,
      filters: null,
      // filters
      filterOptions: filterOptions
    }
  },
  computed: {
    ...mapGetters(['context'])
  },
  methods: {
    change () {
      this.hasChanges = true
    },
    search (searchQuery) {
      this.filters.search = {
        parameter: 'search',
        query: searchQuery
      }
      this.$emit('filter', this.filters)
    },
    update () {
      this.hasChanges = false
      this.filters.preset = 'custom'
      this.$emit('filter', this.filters)
    },
    clear () {
      this.filters = {
        preset: 'all',
        facets: {},
        search: {},
        timestamps: {}
      }
      this.$emit('filter', this.filters)
    }
  },
  props: {
    appliedFilters: {
      type: Object,
      required: true
    }
  },
  watch: {
    appliedFilters: {
      deep: true,
      immediate: true,
      handler (filters) {
        this.filters = filters
      }
    }
  }
}
</script>
